import React from "react";
import { convertTo12HourFormat } from "../../Config/Booking";

export const BookingRightDetails = (props: any) => {
  const {
    booking_time,
    is_subscription,
    cancellation_time,
    session_type,
    session_time,
    session_duration,
    updatedAt,
    post_session_status,
    expert_billing_details: { booking_source },
  } = props;
  return (
    <div className="col-sm-6 px-4">
      <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Subscription:</th>
            <td>{is_subscription ? "true" : "false"}</td>
          </tr>
          <tr>
            <th scope="row">Cancellation Time (24H Format)</th>
            <td>{convertTo12HourFormat(cancellation_time)}</td>
          </tr>
          <tr>
            <th scope="row">Session Type:</th>
            <td>{session_type}</td>
          </tr>
          <tr>
            <th scope="row">Session Time:</th>
            <td>{session_time}</td>
          </tr>
          <tr>
            <th scope="row">Booking Time</th>
            <td>{convertTo12HourFormat(booking_time)}</td>
          </tr>
          <tr>
            <th scope="row">Session Duration:</th>
            <td colSpan={3}>{session_duration}</td>
          </tr>
          <tr>
            <th scope="row">Updated At</th>
            <td colSpan={3}>{updatedAt}</td>
          </tr>
          <tr>
            <th scope="row">Post session status</th>
            <td colSpan={3}>{post_session_status}</td>
          </tr>
          <tr>
            <th scope="row">Booking source</th>
            <td colSpan={3}>{booking_source ? booking_source : "APP"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
